<template>
    <div v-bind:class="['dropdown-block', { 'dropdown-menu-open': dropDownOpen, 'top': isOverflown, 'disabled': disabled}]" :name="name" v-click-outside="onClickOutside" >
        <a href="javascript:;" @click="dropDownOpen = !dropDownOpen">
            <span class="dropdown-menu-item-selected" v-if="selectedItem != null">{{ selectedItem[textField] }}</span>
            <img src="../../img/arrow.png" class="dropdown-img" alt="" />
        </a>
        <div class="dropdown-menu dropdown-list" v-if="!disabled">
            <a class="dropdown-menu-item"
               v-for="item of dropItems"
               :class="{ 'selected': item.Selected === true }"
               @click="onSelect(item)">
                <span>{{ item[textField] }}</span>
            </a>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'

    function isOverflown(element) {
        if(!element){
            return false;
        }
        /*console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
            [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);*/
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }

        export default {
        name: "drop-down",

        props: ['name', 'value', 'items', 'selectedValue', 'dataField', 'textField', 'withSelectItem', 'withSelectItemText', 'cssClass', 'disabled'],

        $_veeValidate: {
                value() {
                    let selectedItem = _.filter(this.dropItems, {Selected:true});
                    let val = selectedItem.length ? selectedItem[0][this.dataField] : null;
                    if(this.withSelectItem === 'true' && val === (this.withSelectItemText || 'Выбрать')){
                      return null;
                    }
                    return val;
                },
                name() {
                    return this.name;
                }
          },

         data(){
            return{
                dropDownOpen: false,
                dropItems: [],
                selectedItem: null,
                isOverflown: false
            }
        },

        watch:{
            items(){
                //console.info('dd -> watch items changed');
                this.setItems();
            },
            value(newVal, oldVal){
                //console.info('dd -> watch value: newVal, oldVal', [newVal, oldVal]);
                let vm = this;

                if(newVal == null || newVal === ''){
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        let el = vm.dropItems[i];
                        el.Selected = vm.withSelectItem === 'true' && i === 0;
                        vm.$set(vm.dropItems, i, el);
                    }
                }else{
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        let el = vm.dropItems[i];
                        if (el[vm.dataField] === newVal) {
                            el.Selected = true;
                            vm.$set(vm.dropItems, i, el);
                        }else{
                            el.Selected = false;
                        }
                    }
                }

                vm.calculateSelecteditem();
            },
            dropDownOpen(){
                let vm = this;
                if(vm.dropDownOpen){
                    vm.$nextTick(() => {
                        vm.isOverflown = isOverflown($(vm.$el).parents('.block-in-page-detail:first').get(0));
                    });
                }else{
                    vm.isOverflown = false;
                }
            }
        },

        methods:{
            calculateSelecteditem() {
                //console.info('dd -> calculateSelecteditem');
                let vm = this;

                if (this.dropItems === undefined) {
                    vm.selectedItem = null;
                } else {
                    let selected = this.dropItems.filter((item) => {
                        return item.Selected === true;
                    });

                    vm.selectedItem = selected.length ? selected[0] : (this.dropItems.length ? this.dropItems[0] : null);
                }
            },

            onSelect(item){
                let vm = this;
                for(let i = 0; i< this.dropItems.length; i++) {
                    let el = this.dropItems[i];
                    el.Selected = el[vm.dataField] === item[vm.dataField];
                    vm.$set(vm.dropItems, i, el);
                }
                //vm.dropItems.__ob__.dep.notify();

                this.dropDownOpen = false;
                this.calculateSelecteditem();

                this.$emit('input', item[vm.dataField]);
                this.$emit('change', item);
            },

            setItems(){
                let vm = this;
                this.dropItems = [];

                if(this.withSelectItem === 'true'){
                    let selectItem = {};
                    selectItem[vm.dataField] = '';
                    selectItem[vm.textField] = (this.withSelectItemText || 'Выбрать');
                    this.dropItems.splice(0, 0, selectItem);
                }

                for(let item of this.items){
                    this.dropItems.push(Object.assign({Selected: false}, item));
                }

                let selectId = vm.selectedValue || vm.value;
                let selectIdWasFound = false;

                if(selectId != null)
                {
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        let el = vm.dropItems[i];
                        if (el[vm.dataField] === selectId || (el[vm.dataField] == selectId && el[vm.dataField]!=='' && this.withSelectItem !== 'true')) {
                            //console.info('found el.Value', el.Value)
                            el.Selected = true;
                            vm.$set(vm.dropItems, i, el);
                            selectIdWasFound = true;
                            break;
                        }
                    }
                }

                if((selectId == null || !selectIdWasFound) && vm.dropItems.length){
                    vm.dropItems[0].Selected = true;
                    this.$emit('input', vm.dropItems[0][vm.dataField]);
                    vm.$set(vm.dropItems, 0, vm.dropItems[0]);
                }

                this.calculateSelecteditem();
            },

            onClickOutside (e, el) {
                this.dropDownOpen = false;
            }
        },

        mounted(){

            this.setItems();
        },

        destroyed() {

        }
    }
</script>

<style scoped>
    /*.dropdown-list.top{*/
        /*bottom: calc(100% + 5px);*/
        /*top: auto;*/
    /*}*/
</style>


// WEBPACK FOOTER //
// Content/src/components/DropDown.vue